'use client'

import 'vanilla-cookieconsent/dist/cookieconsent.css'

import { runKorvoVanillaCookieConsent } from '@korvo/core/lib/cookie-consent'
import { useEffect, useRef } from 'react'

export function CookieConsentClient() {
  const hasInitializedRef = useRef(false)

  useEffect(() => {
    if (hasInitializedRef.current) return
    hasInitializedRef.current = true
    void runKorvoVanillaCookieConsent()
  }, [])

  return null
}
